<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (isGsptEnabled$ | async) {
  <button mat-icon-button
    matTooltip="GSPT Trace"
    (click)="showDialog()"
    >
    <mat-icon svgIcon="gspt" aria-label="GSPT Query"></mat-icon>
  </button>
}

<ng-template #spinner>
  <div matDialogContent fxLayout="column" fxLayoutAlign="center center">
    <h1 class='mat-headline-6'>Working</h1>
    <mat-progress-spinner mode='indeterminate'></mat-progress-spinner>
  </div>
</ng-template>
